import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimeChangeServiceService {
  private timeChangeSubject = new Subject<number>();
  timeChanged$ = this.timeChangeSubject.asObservable();

  private lastDate = Date.now();

  constructor(private zone: NgZone) {
    this.startChecking();
  }

  private startChecking() {
    this.zone.runOutsideAngular(() => {
      const check = () => {
		
        const now = Date.now();
        const diff = now - this.lastDate;

        /**
         * Normally with requestAnimationFrame or setInterval(200),
         * `diff` should be ~200ms (give or take).
         *
         * If the user changes the system clock by hours/days,
         * `diff` will suddenly be in *millions of ms*.
         */
        if (Math.abs(diff) > 2000) {   // threshold: 2 seconds
          this.zone.run(() => {
			console.log("checking");
            this.timeChangeSubject.next(diff); // emit full jump in ms
          });
        }

        this.lastDate = now;
        requestAnimationFrame(check);
      };

      requestAnimationFrame(check);
    });
  }
}
